module.exports = __webpack_public_path__ + "static/media/06_hero_tablet.c6b7e240.jpg";